import { useSelector } from 'react-redux';
// import outletHttpService from "../services/http/stores/outlet.service";
// import React, { useEffect, useState } from "react";
const useRoleAndPerm = () => {
    const auth = useSelector(state => state.auth);
    const roles = auth.roles ?? [];
    const roleType = roles[0]?.role_type?.toLowerCase();
    const userType = auth?.user?.user_type?.toLowerCase();
    const companies = useSelector(state => state.companies.companies);
    const hasPermission = (requiredPermissions) => {
        return requiredPermissions.some(permissionName =>
            roles[0]?.permissions.some(permission => permission.name === permissionName)
        );
    };
    const isVendorRole = roleType === "company"
    const getRedirectLink = (linkType) => {
        switch (linkType) {
            case "company":
                if (isVendorRole && companies?.data?.data[0]?.id) {
                    return `/company/${companies?.data?.data[0]?.id}/view`;
                }
                return "/companies-list";
            default:
                return "/";
        }
    };
    return { hasPermission,roleType,userType,getRedirectLink, isVendorRole };
};

export default useRoleAndPerm;
